import { Routes } from '@angular/router';
import { BookingFormType01Component } from './booking-form-type01/booking-form-type01.component';
export default [
    {
        path     : '',
        component: BookingFormType01Component,
    },
    
] as Routes;
